
import React from 'react';

export const DashboardHeader: React.FC = () => {
  return (
    <div className="bg-heaven-gold/10 pt-40 pb-6 md:pt-40 md:pb-8">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-4xl font-playfair font-bold text-selah-navy mb-4">
          Your <span className="text-heaven-gold">Saved</span> Content
        </h1>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto">
          Access your saved responses from all tools in one place. Review, revisit, and manage your spiritual growth journey.
        </p>
      </div>
    </div>
  );
};
